module.exports = "/wp-content/plugins/farmacy/assets/js/images/f_logo_white-21d12019384434f8790952f2058af779.png";


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/common/farm-branding/img/f_logo_white.png
 ** module id = 205
 ** module chunks = 1 23 27 28 39 42 62 76 81 89 136
 **/